module.exports = __webpack_public_path__ + "static/img/gongshang.c43c123.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/footer/gongshang.png
// module id = c7uL
// module chunks = 0